import { formatDateOnly } from "@/lib/week";
import type { JobLogRecord } from "@/types/domain";

/**
 * Canonical day of a job log. Logs written before `logged_date` existed
 * encoded their day in `created_at` (child backdating overwrote it), so
 * fall back to its local date.
 */
export function loggedDateOf(log: JobLogRecord): string {
  return log.data.logged_date ?? formatDateOnly(new Date(log.created_at));
}
